import axios from 'axios';

const cloudName = 'dvrh3iequ';
const uploadPreset = 'lyx7qr30';

const uploadVideo = async (
    tags: string,
    folder: string,
    file: any,
    onProgress: (percent: number) => void
): Promise<string> => {
    const fd = new FormData();
    fd.append('upload_preset', uploadPreset);
    fd.append('tags', tags);
    fd.append('folder', folder);
    fd.append('file', file);

    const cloudinaryAxios = axios.create();
    delete cloudinaryAxios.defaults.headers.common.Authorization;
    const res = await cloudinaryAxios.post(`https://api.cloudinary.com/v1_1/${cloudName}/upload`, fd, {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (progressEvent: ProgressEvent) => {
            const progressPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(progressPercent);
        },
    });
    return res.data.public_id;
};

const createDocumentUrl = (publicId: string): string => {
    return `https://vsponse.ch/media/${cloudName}/image/upload/${publicId}`;
};

const createVideoPreviewUrl = (publicId: string, transformation: string): string => {
    return `https://vsponse.ch/media/${cloudName}/video/upload/${transformation}/${publicId}.png`;
};

const createVideoUrl = (publicId: string): string => {
    return `https://vsponse.ch/media/${cloudName}/video/upload/${publicId}.mp4`;
};

export { uploadVideo, createDocumentUrl, createVideoPreviewUrl, createVideoUrl };



// WEBPACK FOOTER //
// ./src/cloudinary.ts